module.exports = __webpack_public_path__ + "static/media/anjali_dofe.30d41320.jpg";